var BannerClickProcessor = /** @class */ (function () {
    function BannerClickProcessor($location) {
        'ngInject';
        this.$location = $location;
    }
    BannerClickProcessor.prototype.process = function (data) {
        var action = data.actionUrl;
        var emersonWebsiteHostNamePrefix = 'https://www.emersonecologics.com/';
        var indexOf = action.indexOf(emersonWebsiteHostNamePrefix);
        if (indexOf > 0) {
            var pathPart = action.substring(indexOf - 1 + emersonWebsiteHostNamePrefix.length);
            this.$location.url(pathPart);
        }
        else {
            window.open(action, '_blank');
        }
    };
    return BannerClickProcessor;
}());
export { BannerClickProcessor };
//# sourceMappingURL=banner-click-processor.service.js.map